import { graphql, Link, StaticQuery, useStaticQuery } from "gatsby";
import PropTypes from "prop-types";
import React, { Component } from "react";
import Nav from "./nav";

interface IHeaderProps {
  siteTitle: string;
}

export default class Header extends Component<IHeaderProps> {
  state: { menuOpen: boolean } = { menuOpen: false };

  constructor(props: Readonly<IHeaderProps>) {
    super(props);
    this.toggleMenu = this.toggleMenu.bind(this);
  }

  toggleMenu() {
    this.setState({ menuOpen: !this.state.menuOpen });
    console.log(this.state.menuOpen);
  }

  render() {
    return (
      <StaticQuery
        query={graphql`
          query {
            logoImage: file(
              relativePath: { eq: "markerjs-logo-full-white.svg" }
            ) {
              publicURL
            }
          }
        `}
        render={(data) => (
          <header>
            <div className="fixed z-10">
              <div className="h-16 w-screen px-2 md:px-10 xl:px-0 bg-gradient-to-r from-pink-400 to-red-400 shadow-md flex items-center">
                <div className="w-full mx-auto px-3 max-w-screen-xl flex flex-row justify-between">
                  <Link to="/" className="w-24 max-h-6">
                    <img
                      src={data.logoImage.publicURL}
                      alt={this.props.siteTitle}
                    />
                  </Link>
                  <div
                    className="inline-block md:hidden self-end h-6 w-6 text-yellow-300 fill-current"
                    onClick={this.toggleMenu}
                  >
                    <svg
                      viewBox="0 0 24 24"
                      className={this.state.menuOpen ? "hidden" : ""}
                    >
                      <path d="M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z" />
                    </svg>
                    <svg
                      viewBox="0 0 24 24"
                      className={!this.state.menuOpen ? "hidden" : ""}
                    >
                      <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
                    </svg>
                  </div>
                  <Nav menuOpen={this.state.menuOpen} />
                </div>
              </div>

              <div className="bg-white flex justify-center py-5 shadow-sm">
                marker.js 3 is out now!&nbsp;{" "}
                <a
                  href="https://markerjs.com/"
                  className="underline text-pink-600"
                >
                  Click here to go to the new site
                </a>
                .
              </div>
            </div>
          </header>
        )}
      />
    );
  }
}
